export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '/api';
export const FILE_BASE_URL = process.env.REACT_APP_FILE_BASE_URL || '';
